module.exports = __webpack_public_path__ + "static/media/leftArrowIcon.f6c4c85a.svg";